import { z } from "zod";

export const loginSchema = z.object({
  nombreUsuario: z.string().min(1, "El nombre de usuario es requerido"),
  password: z.string().min(1, "La contraseña es requerida"),
});

export const loginDefaults: LoginFormData = {
  nombreUsuario: "",
  password: "",
};

export type LoginFormData = z.infer<typeof loginSchema>;
